import { queryOptions } from "@tanstack/react-query";
import type {
  ProjectMembersData,
  ProjectMembersResponse,
} from "@/app/members/types";
import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { projectMembersKeys } from "./query-keys";

export const fetchProjectMembers = async (
  scope: OrgProjectScope
): Promise<ProjectMembersData> => {
  const client = getCoordinatorApi(scope);
  const { data } = await client.get<ProjectMembersResponse>("/members");
  return data.data;
};

export const projectMembersQueryOptions = (
  organizationId: string,
  projectId: string
) =>
  queryOptions<ProjectMembersData>({
    queryKey: projectMembersKeys.list({
      scope: { organizationId, projectId },
    }),
    queryFn: () => fetchProjectMembers({ organizationId, projectId }),
  });
